// Shared component (TS-2.5.03). A non-blocking, non-modal banner for exactly the class of thing
// this app's write path produces alongside a SUCCESSFUL save - a staleness reconciliation
// (SaveResult.staleness), a duplicate-business-id finding (decisions.md D-195,
// DataQualityCodes.DuplicateProjectId), or a date/vocabulary echo-back (SaveResult.issues) - none
// of which refuse the write, so none of them may block the screen the way a validation failure
// does. `role="status"` (not "alert") on purpose: these are informational, not urgent refusals,
// and a live region that steals focus or interrupts is the wrong signal for "your save worked,
// here is what else happened."
export interface WarningsBannerItem {
  readonly key: string;
  readonly message: string;
  readonly tone?: "info" | "warning";
}

export interface WarningsBannerProps {
  readonly items: readonly WarningsBannerItem[];
  readonly heading?: string;
}

export function WarningsBanner({ items, heading }: WarningsBannerProps) {
  if (items.length === 0) return null;

  return (
    <div className="eg-warnings-banner" role="status">
      {heading && <p className="eg-warnings-banner__heading">{heading}</p>}
      <ul>
        {items.map((item) => (
          <li key={item.key} className={`eg-warnings-banner__item eg-warnings-banner__item--${item.tone ?? "info"}`}>
            {item.message}
          </li>
        ))}
      </ul>
    </div>
  );
}
